import { Box, Button, Paper, Typography } from '@mui/material'
import { FilterTitleBox } from '../../components/layouts/OneViewBox'
import { findObjectKeyByValue, titleCase } from '../../utils/main'
import { BUTTON_STATUS_COLOR_TYPE, BUTTON_TYPE, STATUS, STATUS_COLOR_TYPE } from '../../utils/constants'

const ButtonComponentsUi = ({ Total, staticTitle, count, STATUSTypeData, onSubmit, STATUSWiseData, Title, colorType, isPointer }) => {

    return (<>
        {STATUSTypeData && <Paper onClick={onSubmit} sx={{ backgroundColor: STATUS_COLOR_TYPE(colorType), display: "flex", justifyContent: "center", alignItems: "center", height: "15vh", width: "100%", borderRadius: "8px", cursor: !isPointer && "pointer", boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)" }}>
            <Box>
                <FilterTitleBox>
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>
                        <Typography variant="h2" color={!colorType ? "#1D013B" : "white"}>
                            {count}
                        </Typography>
                    </Box>
                </FilterTitleBox>
                <FilterTitleBox>

                    {Total ? <Box mt={2} sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>
                        <Typography variant="h4" color={!colorType ? "#1D013B" : "white"}>
                            {Total}
                        </Typography>
                    </Box> : <Box mt={2} sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>
                        <Typography variant="h4" color={!colorType ? "#1D013B" : "white"}>
                            {titleCase(findObjectKeyByValue(STATUSTypeData, BUTTON_TYPE))}
                        </Typography>
                    </Box>}


                </FilterTitleBox>
            </Box>
        </Paper>}

        {Title &&
            <Button onClick={onSubmit} variant={BUTTON_STATUS_COLOR_TYPE(STATUSWiseData)} sx={{ height: "6vh" }}>
                {staticTitle ?
                    <Typography variant="body1" color={STATUSWiseData ? "white" : "primary"}>
                        {staticTitle}
                    </Typography>
                    : <Typography variant="body2" color={STATUSWiseData ? "white" : "primary"}>
                        {titleCase(findObjectKeyByValue(Title, STATUS))}
                    </Typography>}
                <Typography variant="h4" color={STATUSWiseData ? "white" : "primary"}>
                    &nbsp; (&nbsp;{count}&nbsp;)
                </Typography>
            </Button>

        }
    </>)
}

export default ButtonComponentsUi
